var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveAddImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.84,19.96c0-.56.44-1,1-1s1,.44,1,1v6.36h3.71c.51,0,.91.4.91.91s-.4.91-.91.91h-4.71c-.56,0-1-.44-1-1v-7.18Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.55,24.69v-.03c0-2,1.61-3.63,3.78-3.63s3.76,1.6,3.76,3.6v.03c0,2-1.61,3.63-3.78,3.63s-3.76-1.6-3.76-3.6ZM21.14,24.69v-.03c0-1.03-.74-1.92-1.83-1.92s-1.81.87-1.81,1.9v.03c0,1.03.74,1.92,1.83,1.92s1.81-.87,1.81-1.9Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.43,29.76c-.34-.13-.56-.4-.56-.77,0-.44.36-.81.81-.81.13,0,.23.03.33.07.57.26,1.18.42,1.92.42,1.35,0,1.99-.65,1.99-1.9v-.34c-.58.7-1.22,1.13-2.28,1.13-1.62,0-3.09-1.18-3.09-3.25v-.03c0-2.08,1.5-3.25,3.09-3.25,1.08,0,1.72.46,2.25,1.04h0c0-.55.44-.99.99-.99s.99.44.99.99v4.48c0,1.25-.3,2.16-.88,2.74-.65.65-1.65.94-3,.94-.92,0-1.73-.16-2.55-.48ZM28.91,24.31v-.03c0-.95-.74-1.61-1.7-1.61s-1.69.66-1.69,1.61v.03c0,.96.73,1.61,1.69,1.61s1.7-.66,1.7-1.61Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.63,24.69v-.03c0-2,1.61-3.63,3.78-3.63s3.76,1.6,3.76,3.6v.03c0,2-1.61,3.63-3.78,3.63s-3.76-1.6-3.76-3.6ZM37.22,24.69v-.03c0-1.03-.74-1.92-1.83-1.92s-1.81.87-1.81,1.9v.03c0,1.03.74,1.92,1.83,1.92s1.81-.87,1.81-1.9Z",
    fill: "#030303",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 9.88,
    x2: 26.5,
    y2: 9.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 38.01,
    x2: 26.5,
    y2: 38.01,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 9.88,
    x2: 9.88,
    y2: 14.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 9.88,
    x2: 14.88,
    y2: 9.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 38.01,
    x2: 14.88,
    y2: 38.01,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 38.01,
    x2: 9.88,
    y2: 33.02,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 38.01,
    x2: 37.92,
    y2: 33.02,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 38.01,
    x2: 32.92,
    y2: 38.01,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 9.88,
    x2: 32.92,
    y2: 9.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 9.88,
    x2: 37.92,
    y2: 14.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveAddImg);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-add-img.34992262625571297b31ba113bbba5a3.svg";
export { ForwardRef as ReactComponent };